export interface SettingTemplate {
    id: number;
    linkTemplateId: number;
    settingName: string;
    dataType: DataType;
    defaultValue: string;
    dataSource: string;
    required: boolean;
    displayName: string;
    settingDescription: string;
    groupName: string;
    sortingIndex: number;
    accessLevel: AccessLevel;
}

export enum DataType
{
    undefined = 0,
    Boolean = 1,
    DateTime = 2,
    Number = 3,
    Integer = 4,
    Map = 5,
    Text = 6,
    TextArea = 7,
    DropDownMenu = 8,
}

export enum AccessLevel
{
    normal = 0,
    advanced = 1,
    superadmin = 2,
    Hidden = 3
}